var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0B1128;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,38c3.8,0,7-3.1,7-7h2c0,5-4,9-9,9V38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,4v8h-2V4H9v8H7V4H5v12c0,1.6,0.8,3.1,2,4h0v21c0,1.7,1.3,3,3,3s3-1.3,3-3V20h0c1.2-0.9,2-2.4,2-4V4H13z  M11,41c0,0.6-0.4,1-1,1s-1-0.4-1-1V20.9C9.3,21,9.7,21,10,21s0.7,0,1-0.1V41z M13,16c0,1.7-1.3,3-3,3s-3-1.3-3-3v-2h2h2h2V16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,25.8L32.5,4h-2.3L26,13.1v4.7l5.4-11.6L41,26.7c1.2,2.7,1.4,5.8,0.4,8.5c-1,2.7-2.9,4.8-5.5,5.9 c-2.8,1.3-6,1.3-8.8,0c-0.3-0.2-0.7-0.3-1-0.5v2.3c0.1,0,0.1,0.1,0.2,0.1c1.7,0.7,3.4,1.1,5.2,1.1s3.6-0.4,5.2-1.1 c3-1.4,5.4-3.9,6.6-7C44.4,32.6,44.2,29,42.8,25.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,4c-2.8,0-5.1,2.1-5.4,4.9L16.5,19c-0.2,1.5,0.3,3.1,1.4,4.2c0,0,0.1,0.1,0.1,0.1V41c0,1.7,1.3,3,3,3 s3-1.3,3-3V24v-6.4v-0.2V5L23,4z M18.5,19.2l1.1-10.1c0.1-1.4,1.1-2.5,2.4-2.9V23h-0.1c-1,0-1.9-0.4-2.6-1.1 C18.7,21.1,18.4,20.2,18.5,19.2z M22,41c0,0.6-0.4,1-1,1s-1-0.4-1-1V24.6c0.6,0.2,1.3,0.4,1.9,0.4H22V41z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,31h-2c0,3.9-3.1,7-7,7v2C36,40,40,36,40,31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.849cd7aa276cfe62fce7c93ec9c6333e.svg";
export { ForwardRef as ReactComponent };